<template>
  <div>
   
    <h1 >{{ message}}</h1>

    <div v-if="qrNotAssociated == true">
    <h1> No asset found associated to this qr code,</h1>
    <h2> please select asset to associate to this qr code. </h2>
  </div>

  <div v-if="this.loading == true" class="loader"></div>
 <div v-else>

   <div class="button-div">
  <el-dropdown @command="selectProperty" trigger="click">
  <el-button type="primary">
    {{propertySelected}} <i class="el-icon-arrow-down el-icon--right"></i>
  </el-button>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item 
    v-for="(property, index) in propertiesOfReturnedAssets"
     :command="property"
    :key="index"> {{property}} </el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
   </div>
  <div class="assets-parent" > 

   <div style=" padding-bottom: 20px;" v-for="asset in selectedPropertyAssets" :key="asset.machineid">
   <img style="width: 50px; height: 50px; display: inline-block; vertical-align:middle;" :src="asset.imageurl[0]" > 
   <div style="display: inline-block;
    max-width: 80%;
    vertical-align: middle; 
    max-width: calc(100% - 153px);">
  <p class="truncate-text" style=" margin-left: 20px;"> {{asset.machinename}}</p>
   </div>
  <el-button style="display: inline-block; margin-left: 20px; float: right;" type="primary"
   @click.native="associateWithAsset(asset.machineid)"> Select </el-button>
</div>
</div>
 </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  created() {
    this.loading = true;
    EventService.CheckQrAssociateStatus(window.location.href).then(response => {
      this.loading = false;
      if (
        response.data.isassociated &&
        response.data.accesstoproperty &&
        response.data.accesstoasset
      ) {
        this.$router.push({
          path: `/MachinebyId/${response.data.machineid}`
        });
      } else if (!response.data.isassociated) {
        this.qrNotAssociated = true;
        this.loading = true;
      EventService.getUsersAllMachines().then(response => {
        this.loading = false;
      this.allAssets = response.data.machinelists;

      // loop through all assets to check for their property names, put into array to display on dropdown
      this.allAssets.forEach(asset => {
        if(this.propertiesOfReturnedAssets.slice(-1)[0]  != asset.propertyname)
          this.propertiesOfReturnedAssets.push(asset.propertyname);
      });
      // select first property by default
      this.propertySelected = this.propertiesOfReturnedAssets[0];

      });

      } else if (!response.data.accesstoproperty) {
        this.message = "you don't have permission to view this content";
      } else if (!response.data.accesstoasset) {
        this.message = "you don't have permission to view this content";
      }
    });
  },
  data() {
    return {
      message: "",
      allAssets: [],
      loading: false,
      qrNotAssociated: false,
      propertiesOfReturnedAssets: [],
      propertySelected: ""
    };
  },
  methods: {

  associateWithAsset(machineid){
   EventService.associateQrToAsset(window.location.href, machineid).then( response => {
               if (response.status == 200) {
            this.$store.dispatch("addNotification", {
              type: "success",
              Message: "QR code associated!"
            });
            this.$router.replace({ path: `/MachinebyId/${machineid}` });
          }
        })
        .catch(error => {
            console.log(error);
        });   
  },
  selectProperty(propertyname){
   this.propertySelected = propertyname;
  }
  },
  computed: {
   selectedPropertyAssets(){
     if(this.propertySelected != ""){
     return this.allAssets.filter(asset =>
        asset.propertyname == this.propertySelected
      );
     } 

     return this.allAssets
   }
  }
};
</script>

<style scoped>
h1, h2{
  text-align: center;
}
.assets-parent{
    background-color: rgb(244, 244, 244);
    max-width: 450px;
    padding: 2%;
    margin: auto;
    min-width: 450px;
    margin-top: 20px;
}
.button-div{
  text-align: right; margin: auto;
    max-width: 450px;
}
@media (min-width: 250px) and (max-width: 979px){
  
.assets-parent{
  min-width: unset;
  max-width: unset;
}
.button-div{
  width: unset;
  max-width: unset;
}

}
</style>